import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {ENTITLEMENTS_SUB_TABS} from '../constants';
import {entitlementsSubTabTitle} from '../entitlements-subtab.module.styl';
import {EntitlementsTabBar} from '../entitlements-tabs';

import {McpEntitlementsTab} from './mcp-entitlements-tab';

type Props = {
    accountId: number,
};

export const McpEntitlementsSubTab = ({accountId}: Props) => (
    <>
        <EntitlementsTabBar
            accountId={accountId}
            activeSubTab={ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.name}
        />
        <div className={entitlementsSubTabTitle}>
            <StepHeader title={ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.caption}/>
        </div>
        <McpEntitlementsTab accountId={accountId}/>
    </>
);
